import { TableColumn } from '../TableColumn';
import { StyledTableBody } from './styled';

export interface TableBodyProps {
  columns: TableColumn[];
  rows: any[];
}

export const TableBody: React.FC<TableBodyProps> = ({ columns, rows }) => (
  <StyledTableBody>
    {rows.map((row, index) => (
      <tr key={row.id || index}>
        {columns.map(
          (column) =>
            (column.renderIf === undefined || column.renderIf === true) && (
              <td key={column.accessor} data-label={column.label}>
                {row[column.accessor] || (column.label && '-')}
              </td>
            ),
        )}
      </tr>
    ))}
  </StyledTableBody>
);
